/* eslint-disable no-nested-ternary */

import { COMMA, ENTER, SPACE } from '@angular/cdk/keycodes';
import {
  AfterViewInit,
  Component,
  Inject,
  OnInit,
  ViewChild
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef
} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { IGrupo } from '@app/modules/grupo/model';
import { GrupoService } from '@app/modules/grupo/services';
import { IProduto, IProdutoPreco } from '@app/modules/produto/model';
import { ProdutoService } from '@app/modules/produto/services';
import { ProdutosSettingsService } from '@app/modules/produto/services/produto-service/produto-settings.service';
import { UnidadeService } from '@app/modules/unidade/services';
import { DialogConfirmComponent } from '@app/shared/components';
import { validarCEAN } from '@app/shared/utils';
import { filter } from 'rxjs/operators';
import {
  CustomValidators,
  IRoute,
  TokenService
} from 'viggo-sistemas-core-web';
import { Utils } from '../../../../shared/helpers/utils';
import { IFabricante } from '../../../fabricantes/models/fabricante.model';
import { FabricanteService } from '../../../fabricantes/services/fabricante.service';
import { ParceiroService } from '../../../parceiro/services/parceiro.service';
import { TagsList } from '../../../produto/model/produto.model';
import { FastPrecoProdutoComponent } from '../fast-preco-produto/fast-preco-produto.component';
import { AppFormProdutoVariacoesComponent } from './components/app-form-produto-variacoes/app-form-produto-variacoes.component';

@Component({
  selector: 'app-fast-produto',
  templateUrl: './fast-produto.component.html',
  styleUrls: ['./fast-produto.component.scss'],
  providers: [
    UnidadeService,
    GrupoService,
    ProdutoService,
    FabricanteService,
    ParceiroService,
    ProdutosSettingsService
  ]
})
export class FastProdutoComponent implements OnInit, AfterViewInit {
  @ViewChild(AppFormProdutoVariacoesComponent)
  _formProdutosVariacoes: AppFormProdutoVariacoesComponent;

  teclasSeparadoras = [ENTER, COMMA, SPACE];

  loadingCodigo = true;
  viewInit = false;
  readOnly = true;
  mostrarGrade = false;
  updateRowsVariacao = false;

  public form: UntypedFormGroup;
  settings = { variacoes: [] };
  public tags = [] as TagsList[];

  produto: IProduto;
  produtoPrecos: IProdutoPreco[];
  constructor(
    private dialogRef: MatDialogRef<FastProdutoComponent>,
    private fb: UntypedFormBuilder,
    public fabricanteService: FabricanteService,
    public parceiroService: ParceiroService,
    protected actRoute: ActivatedRoute,
    public unidadeService: UnidadeService,
    public grupoService: GrupoService,
    private produtoService: ProdutoService,
    private prodSettingService: ProdutosSettingsService,
    public tokenService: TokenService,
    public matSnack: MatSnackBar,
    protected matDialog: MatDialog,
    @Inject(MAT_DIALOG_DATA)
    private data: {
      entity: any;
      readOnly?: boolean;
      mostrarGrade?: boolean;
      updateRowsVariacao?: boolean;
    }
  ) {
    this.produto = this.data.entity;
    this.produto.precos = [];

    if (this.data.mostrarGrade !== null && this.data.mostrarGrade !== undefined)
      this.mostrarGrade = this.data.mostrarGrade;

    if (
      this.data.updateRowsVariacao !== null &&
      this.data.updateRowsVariacao !== undefined
    )
      this.updateRowsVariacao = this.data.updateRowsVariacao;

    if (this.data.readOnly !== null && this.data.readOnly !== undefined)
      this.readOnly = this.data.readOnly;
    else this.readOnly = this.data.entity.id ? true : false;
  }

  ngOnInit(): void {
    const { entity } = this.data;
    this.form = this.fb.group({
      codigo_barra: [
        entity.codigo_barra || '',
        [
          Validators.minLength(8),
          Validators.maxLength(14),
          CustomValidators.existSpecialChar()
        ]
      ],
      descricao: [
        entity.descricao || '',
        [
          Validators.required,
          Validators.maxLength(60),
          CustomValidators.isEmptyValue()
        ]
      ],
      unidade: [
        entity.unidade || null,
        [
          Validators.required,
          CustomValidators.typeIs('object'),
          CustomValidators.isEmptyValue()
        ]
      ],
      grupo: [
        entity.grupo || null,
        [
          Validators.required,
          CustomValidators.typeIs('object'),
          CustomValidators.isEmptyValue()
        ]
      ],
      valor_unitario: [
        entity.valor_unitario || 0,
        [
          Validators.required,
          // CustomValidators.validateEqualsMinZero(),
          CustomValidators.validateCurrencyValues(15, 3),
          CustomValidators.existSpecialChar(true)
        ]
      ],
      valor_minimo: [
        entity.valor_minimo || 0,
        [
          Validators.required,
          // CustomValidators.validateEqualsMinZero(),
          CustomValidators.validateCurrencyValues(15, 2),
          CustomValidators.existSpecialChar(true)
        ]
      ],
      descricao_completa: [
        entity.descricao_completa || null,
        [Validators.maxLength(200), CustomValidators.isEmptyValue()]
      ],
      descricao_secundaria: [
        entity.descricao_secundaria || null,
        [Validators.maxLength(50), CustomValidators.isEmptyValue()]
      ],
      fabricante: [
        entity.fabricante || null,
        [
          Validators.required,
          CustomValidators.typeIs('object'),
          CustomValidators.isEmptyValue()
        ]
      ],
      validar_codigo_barra: [
        entity.validar_codigo_barra || false,
        [Validators.required]
      ],
      quantidade: [
        entity.quantidade || 0,
        [
          Validators.required,
          CustomValidators.validateCurrencyValues(15, 2),
          CustomValidators.existSpecialChar(true)
        ]
      ],
      usa_grade: [entity.usa_grade || false, [Validators.required]]
    });

    this.validarCamposForm();
  }

  validarCamposForm() {
    const {
      valor_unitario,
      valor_minimo,
      validar_codigo_barra,
      codigo_barra
    } = this.form.controls;

    valor_unitario.valueChanges.subscribe(value => {
      if (
        valor_minimo.value !== null &&
        valor_minimo.value !== '' &&
        value !== null &&
        value !== '' &&
        !valor_unitario.hasError('before_split') &&
        !valor_unitario.hasError('notNumbers') &&
        !valor_unitario.hasError('errorComma') &&
        !valor_unitario.hasError('after_split') &&
        !valor_unitario.hasError('errorDots') &&
        !valor_unitario.hasError('max_value') &&
        !valor_unitario.hasError('invalidNumber')
      ) {
        valor_unitario.setErrors(
          this.validateCurrency(value, 'valor_unitario', valor_minimo.value)
        );
      }
    });

    valor_minimo.valueChanges.subscribe(value => {
      if (
        valor_unitario.value !== null &&
        valor_unitario.value !== '' &&
        value !== null &&
        value !== '' &&
        !valor_unitario.hasError('before_split') &&
        !valor_unitario.hasError('notNumbers') &&
        !valor_unitario.hasError('errorComma') &&
        !valor_unitario.hasError('after_split') &&
        !valor_unitario.hasError('errorDots') &&
        !valor_unitario.hasError('max_value') &&
        !valor_unitario.hasError('invalidNumber')
      ) {
        valor_unitario.setErrors(
          this.validateCurrency(value, 'valor_minimo', valor_unitario.value)
        );
      }
    });

    validar_codigo_barra.valueChanges.subscribe(v => {
      if (
        v &&
        codigo_barra.value &&
        codigo_barra.value.length >= 8 &&
        !codigo_barra.hasError('minlength') &&
        !codigo_barra.hasError('maxlength')
      ) {
        if (!validarCEAN(codigo_barra.value)) {
          codigo_barra.setErrors({ invalidCEAN: true });
          this.form.updateValueAndValidity();
        }
      } else if (v && !codigo_barra.value) {
        codigo_barra.setErrors({ required: true });
        codigo_barra.markAsDirty();
        this.form.updateValueAndValidity();
      } else if (
        !v &&
        (!codigo_barra.hasError('required') || !codigo_barra.value)
      ) {
        codigo_barra.setErrors(null);
        this.form.updateValueAndValidity();
      }
    });

    codigo_barra.valueChanges.subscribe(cod => {
      if (
        cod &&
        cod.length >= 8 &&
        !codigo_barra.hasError('minlength') &&
        !codigo_barra.hasError('maxlength') &&
        validar_codigo_barra.value
      ) {
        if (!validarCEAN(cod)) {
          codigo_barra.setErrors({ invalidCEAN: true });
          this.form.updateValueAndValidity();
        }
      } else if (!cod && validar_codigo_barra.value) {
        codigo_barra.setErrors({ required: true });
        codigo_barra.markAsDirty();
        this.form.updateValueAndValidity();
      } else if (codigo_barra.valid) {
        codigo_barra.setErrors(null);
        this.form.updateValueAndValidity();
      }
    });

    this.checkUnidade();
  }

  checkDisponibilidade(action: string, params = '', url_name: string) {
    var routesAuthorization = this.verificarRotasDeAcesso(
      this.tokenService.getRoutes(),
      url_name
    ) as IRoute[];

    return this.validarAdicao(routesAuthorization, action, params, url_name);
  }

  /**
   * Valida as rotas do usuário
   * @param routes
   * @param url_name
   * @returns
   */
  verificarRotasDeAcesso(routes: IRoute[], url_name: string): IRoute[] {
    if (routes && routes.length > 0 && url_name) {
      return routes.filter(r => new RegExp(`^${url_name}`).test(r.url));
    }
  }

  /**
   * Valida se as rotas do usuário são equivalentes ao pacote de rotas do fiscal
   * @param routesAuthorization
   * @param action
   * @param params
   * @param url_name
   * @returns
   */
  validarAdicao(
    routesAuthorization: IRoute[],
    action: string,
    params = '',
    url_name: string
  ): boolean {
    if (routesAuthorization && routesAuthorization.length > 0) {
      const url_return = routesAuthorization.find(
        route => route.url === url_name && route.method === action
      );
      return url_return ? true : false;
    }
  }

  parceiroDisplay = (fabricante: IFabricante): string => {
    if (fabricante) {
      return fabricante.parceiro.nome_razao_social;
    }
    return '';
  };

  /**
   * Valida se o campo de valor unitario está acima do valor mínimo
   * @returns o erro
   */
  validateCurrency(value, controlName: string, valueAux) {
    value = Utils.replaceCommaToDot(value);
    valueAux = Utils.replaceCommaToDot(valueAux);
    if (value && controlName === 'valor_minimo') {
      if (valueAux < value) return { menor_valor: true };
      else return null;
    } else if (value && controlName === 'valor_unitario') {
      if (valueAux > value) return { menor_valor: true };
      else return null;
    }
  }

  checkUnidade() {
    const { unidade: uEntity } = this.data.entity;
    const { unidade } = this.form.controls;
    if (uEntity && !unidade.value) {
      this.unidadeService
        .getEntitiesByParams({
          where: {
            sigla: uEntity,
            domain_id: this.tokenService.getDomain().id
          }
        })
        .subscribe(res => {
          if (res.length) unidade.setValue(res[0]);

          unidade.markAsTouched();
        });
    }
  }

  displayGrupo = (entity: IGrupo) => {
    return entity && entity.parent_id
      ? `${entity.parent.nome} - ${entity.nome}`
      : entity && entity.nome
      ? entity.nome
      : '';
  };

  salvar() {
    const { value } = this.form;

    var entity = {
      domain_id: this.tokenService.getDomain().id,
      ...value,
      unidade_id: value.unidade.id,
      grupo_id: value.grupo.id,
      quantidade: this.produto.id
        ? undefined
        : Utils.replaceCommaToDot(value.quantidade),
      valor_unitario: Utils.replaceCommaToDot(value.valor_unitario),
      valor_minimo: Utils.replaceCommaToDot(value.valor_minimo),
      precos: this.produtoPrecos,
      fabricante_id: value.fabricante.id,
      variacoes: this._formProdutosVariacoes
        ? this._formProdutosVariacoes.produtos_variacao.value
        : []
    };
    entity.precos = this.produto.precos.map(p => ({
      ...p,
      tabela_preco: undefined
    }));

    entity = Utils.trimAttributes(entity);
    entity.tag = this.tags;

    entity.variacoes.forEach(it => {
      it.quantidade = Utils.replaceCommaToDot(it.quantidade);
      it.valor = Utils.replaceCommaToDot(it.valor);
    });

    if (this.validarProdutosEmGrade(entity)) {
      if (Array.isArray(entity.tag)) entity.tag = entity.tag.join(' ');
      // CHECA SETTINGS
      if (this._formProdutosVariacoes && this._formProdutosVariacoes.settings)
        this.settings = this.getSettingsProduto();

      localStorage.setItem('SAVE_PRODUTO', JSON.stringify(entity));

      entity = Utils.onlyAttributes(
        {
          ...entity,
          variacoes: entity.variacoes.map(i =>
            Utils.clearObject(
              Utils.onlyAttributes(i, [
                'produto_id',
                'identificadores',
                'quantidade',
                'domain_id',
                'descricao',
                'sku',
                'valor',
                'id'
              ])
            )
          )
        } as IProduto,
        [
          'id',
          'codigo',
          'codigo_barra',
          'descricao',
          'descricao_completa',
          'descricao_secundaria',
          'domain_id',
          'fabricante_id',
          'tag',
          'grupo_id',
          'precos',
          'quantidade',
          'unidade_id',
          'validar_codigo_barra',
          'valor_minimo',
          'valor_unitario',
          'variacoes',
          'usa_grade'
        ]
      ) as IProduto;
      if (this.produto.id) {
        entity.id = this.produto.id;
        this.update(entity);
      } else {
        this.insert(entity);
      }
    }
  }

  insert(entity: IProduto) {
    this.produtoService
      .insert(entity)
      .pipe(filter(result => !!result))
      .subscribe(produto => {
        this.produtoService
          .getEntity(produto.id, [
            'unidade',
            'fabricante.parceiro',
            'grupo',
            'variacoes'
          ])
          .subscribe(res => {
            this.prodSettingService
              .update(this.settings, produto.id)
              .subscribe(() => {
                localStorage.removeItem('VARIACOES_SETTINS');
                localStorage.removeItem('SAVE_PRODUTO');
                localStorage.removeItem('PRODUTO_BACKUP');
                localStorage.removeItem('PRODUTOS_VARIACAO_BACKUP');
                this.matSnack.open('Produto foi cadastrado', 'X', {
                  duration: 2000,
                  horizontalPosition: 'right',
                  verticalPosition: 'top',
                  panelClass: ['msg-success']
                });
                this.dialogRef.close(res);
              });
          });
      });
  }

  update(entity: IProduto) {
    this.produtoService
      .update(entity)
      .pipe(filter(result => !!result))
      .subscribe(produto => {
        this.produtoService
          .getEntity(produto.id, [
            'unidade',
            'fabricante.parceiro',
            'grupo',
            'variacoes'
          ])
          .subscribe(res => {
            this.prodSettingService
              .update(this.settings, produto.id)
              .subscribe(() => {
                this.matSnack.open('Produto foi atualizado', 'X', {
                  duration: 2000,
                  horizontalPosition: 'right',
                  verticalPosition: 'top',
                  panelClass: ['msg-success']
                });
                this.dialogRef.close(res);
              });
          });
      });
  }

  public editAddPrecoProduto(preco: IProdutoPreco = {} as IProdutoPreco): void {
    const observer = this.matDialog
      .open(FastPrecoProdutoComponent, {
        width: '325px',
        data: {
          preco
        }
      })
      .afterClosed();

    observer.subscribe((result?: IProdutoPreco) => {
      if (result) {
        const { produto } = this;
        const index = produto.precos.findIndex(
          auxPreco =>
            auxPreco.tabela_preco_id === result.tabela_preco_id ||
            (auxPreco.id === result.id && auxPreco.id !== undefined)
        );
        if (index >= 0) {
          produto.precos[index] = result;
        } else {
          produto.precos.push(result);
        }
        this.produto = produto;
        this.produtoPrecos = produto.precos;
      }
    });
  }

  removePrecoProduto(event: MouseEvent, index: number) {
    event.stopPropagation();
    const observer = this.matDialog
      .open(DialogConfirmComponent, {
        data: {
          titulo: 'Excluir Preço Produto',
          msg: `Deseja excluir a(o) Preço Produto
          ${this.produto.precos[index].tabela_preco.nome}`
        }
      })
      .afterClosed();
    observer.subscribe((result: boolean): void => {
      if (result) this.produto.precos.splice(index, 1);
    });
  }

  close(): void {
    this.dialogRef.close();
  }

  changeTag(tag) {
    this.tags = tag.map(t => t.value);
  }

  get formDadosValid() {
    const {
      codigo_barra,
      descricao,
      unidade,
      grupo,
      valor_unitario,
      valor_minimo,
      fabricante
    } = this.form.controls;
    if (
      codigo_barra.invalid ||
      descricao.invalid ||
      unidade.invalid ||
      grupo.invalid ||
      valor_unitario.invalid ||
      valor_minimo.invalid ||
      fabricante.invalid
    ) {
      codigo_barra.markAllAsTouched();
      descricao.markAllAsTouched();
      grupo.markAllAsTouched();
      unidade.markAllAsTouched();
      valor_unitario.markAllAsTouched();
      valor_minimo.markAllAsTouched();
      fabricante.markAllAsTouched();
    }
    return (
      this.viewInit &&
      (codigo_barra.invalid ||
        descricao.invalid ||
        unidade.invalid ||
        grupo.invalid ||
        valor_unitario.invalid ||
        valor_minimo.invalid ||
        fabricante.invalid)
    );
  }

  get formCatalogoValid() {
    const { descricao_completa, descricao_secundaria } = this.form.controls;
    if (descricao_completa.invalid || descricao_secundaria.invalid) {
      descricao_completa.markAsTouched();
      descricao_secundaria.markAsTouched();
    }
    return (
      this.viewInit &&
      (descricao_completa.invalid || descricao_secundaria.invalid)
    );
  }

  validateOnlyNumbers(event) {
    if (
      !/^\d+$/.test(event.key) &&
      !/[`,.]/.test(event.key) &&
      !event.ctrlKey &&
      event.key !== 'Backspace' &&
      event.key !== 'Delete' &&
      event.key !== 'Tab' &&
      event.key !== 'ArrowLeft' &&
      event.key !== 'ArrowRight'
    )
      return false;
  }

  ngAfterViewInit(): void {
    this.viewInit = true;
  }

  get formVariacoesValid() {
    return this._formProdutosVariacoes
      ? this._formProdutosVariacoes.produtos_variacao.value.length > 0
      : ({} as UntypedFormGroup);
  }

  /**
   * Atualiza a informação de settings do produto
   */
  callUpdateSettings() {
    this.prodSettingService
      .update(this.settings, this.produto.id)
      .subscribe(() => {});
  }

  /**
   * Para cada item variação do produto é checado se seus valores de quantidade
   * e valor estão respeitando a quantidade e valor mínimo do pai
   * @param produto
   * @returns
   */
  validarProdutosEmGrade(produto: IProduto) {
    var qtd = 0;
    var foiMenorQueMinimo = 0;

    if (
      this._formProdutosVariacoes &&
      this._formProdutosVariacoes.produtos_variacao.value.length
    ) {
      this._formProdutosVariacoes.produtos_variacao.value.forEach(it => {
        qtd += it.quantidade;

        if (it.valor < Utils.replaceCommaToDot(produto.valor_minimo))
          foiMenorQueMinimo++;
      });

      if (
        this._formProdutosVariacoes &&
        this._formProdutosVariacoes.produtos_variacao.value.length &&
        qtd !== Utils.replaceCommaToDot(produto.quantidade) &&
        this.usaControleEstoque &&
        false //FIXME: REMOVI ESSA VALIDACAO PARA N COLOCAR DE INICIO A QTD NA CRIACAO
      ) {
        this.matSnack.open(
          'Quantidade de estoque das variações deve ser igual a do produto!',
          'X',
          {
            duration: 3000,
            horizontalPosition: 'right',
            verticalPosition: 'top',
            panelClass: ['msg-error']
          }
        );
        return false;
      } else if (foiMenorQueMinimo !== 0) {
        this.matSnack.open(
          'Valor do produto variação não pode ser menor que o valor mínimo do produto!',
          'X',
          {
            panelClass: ['msg-error'],
            horizontalPosition: 'right',
            verticalPosition: 'top',
            duration: 3000
          }
        );
        return false;
      }
      return true;
    } else return true;
  }

  /**
   * Resgata somente os campos que serão necessários para enviar nas
   * settings do produto
   * @returns
   */
  getSettingsProduto() {
    var settings = this._formProdutosVariacoes.settings;
    localStorage.setItem(
      'VARIACOES_SETTINS',
      JSON.stringify(this._formProdutosVariacoes.clearSettingsObj())
    );

    settings.variacoes = settings['variacoes'].map(j =>
      Utils.onlyAttributes(j, ['variacao_id', 'itens', 'descricao'])
    );

    settings['variacoes'].forEach(it => {
      it.itens = it.itens.map(j =>
        Utils.onlyAttributes(j, [
          'variacao_item_id',
          'descricao',
          'variacao_id'
        ])
      );
    });

    return settings;
  }

  get usaControleEstoque() {
    return this.tokenService.getDomain().settings['regras']['controle'][
      'produto'
    ]['controle_estoque'] !== undefined
      ? this.tokenService.getDomain().settings['regras']['controle']['produto'][
          'controle_estoque'
        ]
      : false;
  }
}
